var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVibesSemicircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 146,
    viewBox: "0 0 95 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 2.66449C55.2827 2.19843 22.6563 34.6976 22.8393 73.4137C22.365 112.354 55.0663 145.195 93.9917 144.995C54.825 145.461 21.8159 112.579 22.0072 73.4137C21.5829 44.8344 39.8557 17.3619 66.3246 6.60101C75.0532 2.93081 84.5224 1.03329 94 1V2.66449Z",
    fill: "#7FB4BF",
    stroke: "#7FB4BF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97.679C81.1407 97.3097 69.7797 108.261 69.8653 120.916C69.4886 133.746 80.8668 145.084 94 144.991C80.6784 145.36 68.915 134.015 69.0092 120.916C68.6239 107.64 80.4045 95.8999 94 96.0006V97.679Z",
    fill: "#7FB4BF",
    stroke: "#7FB4BF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50.6591C67.8524 50.3024 45.7933 71.7957 45.8695 97.4117C45.5055 123.26 67.6323 145.077 94 144.994C74.7089 145.309 56.1457 133.248 48.8406 115.744C38.2597 91.6133 50.3558 62.7703 75.1321 52.7744C81.0828 50.319 87.5329 49.0332 94 49V50.6591Z",
    fill: "#7FB4BF",
    stroke: "#7FB4BF",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99585 59.5023L0.803223 59.242L2.25861 52.663L3.45124 52.9233L2.87179 55.5356L9.81959 57.0751L9.51766 58.4394L2.56986 56.8999L1.99041 59.5123L1.99585 59.5023Z",
    fill: "#7FB4BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.978 52.3036L3.04744 49.7371L3.4779 48.4104L6.89175 49.5166L8.15279 45.604L4.73894 44.4978L5.1694 43.171L13.0999 45.7375L12.6695 47.0643L9.17249 45.9322L7.91146 49.8448L11.4084 50.9768L10.978 52.3036Z",
    fill: "#7FB4BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1041 43.1424L6.45114 39.8396L8.88191 34.2059L10.0357 34.7042L8.15853 39.0587L10.3008 39.9783L11.7653 36.5845L12.7538 37.0058L11.2893 40.3995L13.5093 41.3549L15.3919 36.9904L16.5457 37.4887L14.1172 43.1301L14.1041 43.1424Z",
    fill: "#7FB4BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0542 21.2747L21.4621 28.4533L20.73 29.6678L11.9582 28.0879L12.7392 26.7835L18.3675 27.8317L19.8009 28.1971L18.8131 27.0961L15.2763 22.5614L16.0519 21.2669L16.0542 21.2747Z",
    fill: "#7FB4BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4424 23.857L17.6121 19.0781L18.4079 17.9372L25.2382 22.716L24.4424 23.857Z",
    fill: "#7FB4BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8843 20.3928L20.4114 15.1477L22.8344 12.1589C24.0765 10.6261 25.2524 10.4886 26.243 11.2868C27.0256 11.9199 27.1964 12.8678 26.6348 13.8641C27.5148 13.0086 28.5435 12.8559 29.4697 13.606C30.6385 14.5529 30.5286 15.8857 29.2679 17.4408L26.8821 20.3851L26.8843 20.3928ZM22.23 14.8289L24.1046 16.3477L25.421 14.7258C26.2269 13.7328 26.1848 12.965 25.6104 12.497C25.0705 12.0608 24.4213 12.135 23.5837 13.1625L22.23 14.8289ZM24.8871 16.9807L26.8185 18.5498L28.2333 16.8066C28.7014 16.2322 28.9084 15.7684 28.8853 15.4061C28.8445 15.0406 28.6871 14.7347 28.3999 14.5007C27.7955 14.0164 27.1264 14.2223 26.2966 15.2475L24.8894 16.9884L24.8871 16.9807Z",
    fill: "#7FB4BF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7678 13.3538L26.8059 7.53837L31.0901 3.15277L31.9864 4.02911L28.6738 7.41478L30.336 9.03817L32.9201 6.39609L33.6859 7.14315L31.1018 9.78523L32.8331 11.4721L36.1511 8.07646L37.0474 8.95279L32.7578 13.3484L32.7678 13.3538Z",
    fill: "#7FB4BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibesSemicircles);
export default __webpack_public_path__ + "static/media/vibes-semicircles.b115e4a1096da6b5e33d76241ad12c10.svg";
export { ForwardRef as ReactComponent };